module.exports = __webpack_public_path__ + "img/Adam.00635b1f.png";